import { PayloadAction } from "@reduxjs/toolkit";
import { takeLatest, put, call } from "redux-saga/effects";
import { orderPlaced } from "./OrderAPI";
import { orderActions } from "./reducer";
import { toastError, toastSuccess, toastWarning } from "../../Methods/Helpers/ToastHelper";
import { CreateOrderModel } from "../../Services/Models/Order/OrderModel";
import { OrderPostAPIResponse } from "./types";

function* onOrderPlaced({ payload: orders }: PayloadAction<CreateOrderModel>): any {
  try {
    // Old Logic
    const { data: { code, data, errors, status } }: OrderPostAPIResponse = yield call(orderPlaced, orders);
    if (status && code === 200) {
      yield put(orderActions.placeOrderCompleteSuccess({ data, errors: [] }));
      yield call(toastSuccess, "Order(s) placed successfully");
    } else if (status && code === 207) {
      yield call(toastWarning, "Order(s) processed partially, check below for details");
      yield put(orderActions.placeOrderCompleteSuccess({ data, errors }));
    } else if (!status && code === 400) {
      yield put(orderActions.placeOrderCompleteFailed({ errors }));
      yield call(toastError, "Please check the patient data, error in processing order");
    } else {
      var e = new Error("Oops, something is wrong with us, please try again.");
      throw e;
    }
  } catch (error: any) {
    yield put(orderActions.placeOrderError());
    console.log("error: ", error.message || error.toString());
    yield call(toastError, error.message || error.toString());
  }
}

function* OrdersSaga() {
  yield takeLatest(orderActions.placeOrderStart.type, onOrderPlaced);
}

export default OrdersSaga;
